module.exports = __webpack_public_path__ + "img/logo-um-ft-ang.ba138999.png";